import { Bootstrap } from "made-this-ui";
import Head from "next/head";
import { AppProps } from "next/app";
import themeAdmin from "admin/lib/theme";

export const ShareApp = ({ Component, pageProps }: AppProps) => {
  return (
    <Bootstrap
      theme={themeAdmin}
      graphqlOptions={{ endpoint: "/admin/graphql/public" }}
    >
      <Head>
        <title>Ejsingholm</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>

      <Component {...pageProps} />
    </Bootstrap>
  );
};
